import React from 'react';
import { PulseCheckWrapper } from '../PulseCheck.wrapper';
import { SetGoal } from './SetGoal';

interface Props {
  clientId: string;
  categoryId: string;
  goalId: string;
}

export default (props: Props) => {
  return (
    <PulseCheckWrapper>
      <SetGoal {...props} />
    </PulseCheckWrapper>
  );
};
